<template>
  <!-- popup add item -->
  <!-- <vs-popup title="Add New Item in to Stock" :active.sync="popupAdd"> -->
  <div>
    <vs-input
      class="input"
      label="Name"
      placeholder="Name Product"
      disabled="true"
      v-model="name"
    />
    <br />
    <vs-row vs-w="12" vs-type="flex">
      <vs-col vs-w="10">
        <vs-input
          class="input"
          label="MAC Address"
          placeholder="Number of Mac Address"
          v-model="macAddress"
          @change="findMac"
        />
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="flex-end" vs-align="flex-end">
        <vs-button @click="popupScan = true" color="#e74639" type="filled">
          <img src="@/assets/images/Unicorn/qr_scan.gif" />

        </vs-button>
        <vs-popup title="Scan QR Code" :active.sync="popupScan">
          <!-- open camara scan qr code -->
          <div style="width: 100%; height: 12%" v-if="popupScan">
            <StreamBarcodeReader
              @decode="(result) => onDecode(result)"
              @loaded="() => onLoaded()"
            ></StreamBarcodeReader>
            Incoming Value: {{ text || "Nothing" }}
          </div>
        </vs-popup>
      </vs-col>
    </vs-row>

    <vs-row vs-w="12">
      <vs-col vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
        <vs-input
          class="input"
          type="number"
          label="Quantity"
          placeholder="Number"
          disabled="true"
          v-model="quantity"
        />
      </vs-col>
      <vs-col vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
        <vs-input
          class="input"
          label="Time"
          placeholder="Time"
          disabled="true"
          v-model="timeStamp"
        />
      </vs-col>
    </vs-row>

    <br />
    <vs-textarea
      label="Details"
      placeholder="Details"
      disabled="true"
      counter="100"
      maxlength="100"
      :counter-danger.sync="counterDanger"
      v-model="details"
    />
    <br />
    <!-- btn add new item -->
    <vs-row vs-type="flex" vs-justify="flex-end" vs-align="center">
      <vs-button
        @click="onRemoveItem"
        color="#e74639"
        type="filled"
        icon="remove"
        >Remove</vs-button
      >
    </vs-row>
  </div>
  <!-- </vs-popup> -->
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import useSound from "vue-use-sound";
import buttonSfx from "@/assets/images/Unicorn/scan.mp3";

export default {
  props: {
    timeStamp: {
      type: String,
      default: null,
    },
  },
  components: {
    StreamBarcodeReader,
  },
  data() {
    return {
      popupScan: false,
      name: "",
      macAddress: "",
      details: "",
      quantity: null,
      counterDanger: false,
      text: "",
      id: null,
      idItem: null,
    };
  },
  setup() {
    const [play] = useSound(buttonSfx);

    return {
      play,
    };
  },
  methods: {
    onRemoveItem() {
      // add data to database
      // call api

      if (this.macAddress != "") {
        let data = {
          id: this.idItem,
        };
        console.log(data);

        this.$API.post("indoor/checkout", data).then((res) => {
          console.log(res);

          // call method in store
          this.$store.dispatch("unicorn/getData");

          this.$vs.notify({
            title: "Notification",
            text: "Remove data success",
            color: "success",
            position: "top-center",
          });
        });

        this.$emit("close-popup-remove", false);
        this.popupAdd = false;
      } else {
        this.$vs.notify({
          title: "Warning",
          text: "Please enter the MAC Address",
          color: "danger",
          position: "top-center",
        });
      }
    },
    findMac() {
      //math data with mac address
      const dataTable = this.$store.getters["unicorn/dataTable"];

      for (let index = 0; index < dataTable.length; index++) {
        const element = dataTable[index];

        if (element.mac == this.macAddress) {
          this.name = element.name;
          this.details = element.detail;
          this.quantity = element.quantity;
          this.idItem = element.id
          break;
        }else{
          this.name = '';
          this.details = '';
          this.quantity = '';
        }
      }
    },
    onDecode(result) {
      console.log(result, this.id);
      this.text = result;
      this.macAddress = result;
      // play sound scan
      this.play();
      this.popupScan = false;

      this.findMac();

      //   clear data read
      if (this.id) clearTimeout(this.id);

      this.id = setTimeout(() => {
        if (this.text === result) {
          this.text = "";
        }
      }, 5000);
    },
    onLoaded() {
      console.log("load");
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  width: 100%;
}
img {
  width: 100%;
}
</style>